export enum SectionType {
    ProfileBio = 1,
    Sponsor = 2
}